/* istanbul ignore file  */
import { GuideProgressContextProvider } from 'contexts/GuideProgressContext';
import { SSOConfigFieldsContextProvider } from 'contexts/SSOConfigFieldsContext';
import React, { PropsWithChildren } from 'react';

const AuthenticatedProviders: React.FC<PropsWithChildren> = ({
	children = null
}) => (
	<GuideProgressContextProvider>
		<SSOConfigFieldsContextProvider>{children}</SSOConfigFieldsContextProvider>
	</GuideProgressContextProvider>
);

export default AuthenticatedProviders;
